<template>
<div>
<div class="content_card" >
<div class="content_card_content">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>
<div class="grid">


<div class="col-12 md:col-6">
<h3 class="text-primary align-items-center flex">Bağlı Yöneticiler  <Badge v-if="admin_connections.length" :value="admin_connections.length" severity="success" class="ml-2"></Badge></h3>
<ul class="userlist">
<li v-for="item in admin_connections">
 <router-link class="text-primary p-link no-underline" :to="{ name: 'User' , params: { id: item.id }}">{{ item.name}} - Açık Tab {{item.opentabs}}</router-link>
</li>

</ul>
</div>
<div class="col-12 md:col-6">
<h4 class="text-primary align-items-center flex">Bağlı Tedarikçi Kullanıcıları <Badge v-if="supplier_connections.length" :value="supplier_connections.length" severity="success" class="ml-2"></Badge></h4>
<ul class="userlist">
<li v-for="item in supplier_connections">
 <router-link class="text-primary p-link no-underline" :to="{ name: 'User' , params: { id: item.id }}">{{ item.name}} - <span class="text-purple-500">{{item.email}}</span> - Açık Tab {{item.opentabs}}</router-link>
</li>

</ul>	
</div>

</div>
</template>

</div>

</div>
</div>
</template>

<script>
export default {

  name: 'ConnectedUsers',

  data () {
    return {
    	data:null,
    	loading:true,    
    	admin_connections:[],
    	supplier_connections:[],
    }
  },
  sockets: {
  	connected_users_updated() {
        console.log("connected_users_updated")
        this.refreshConnectedData()
    },
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.loading = true
  		this.data = await this.generalApiGetWithoutLoader("get_current_sockets")
  		
  		await this.findUnique()
  		
  	},
  	async findUnique()
  	{
  		this.admin_connections = await []
  		for(let admin of this.data.admin_connections)
  		{
  			
  			admin.opentabs = await 1
  			let ind = await this.admin_connections.findIndex((item)=>{return item.id == admin.id})
  			if(ind ==-1)
  			{
  				await this.admin_connections.push(admin)
  			}
  			else
  			{
  				this.admin_connections[ind].opentabs++
  			}
  		}
  		this.supplier_connections = await []
  		for(let supplier of this.data.supplier_connections)
  		{
  			
  			supplier.opentabs = await 1
  			let ind = await this.supplier_connections.findIndex((item)=>{return item.id == supplier.id})
  			if(ind ==-1)
  			{
  				await this.supplier_connections.push(supplier)
  			}
  			else
  			{
  				this.supplier_connections[ind].opentabs++
  			}
  		}
  		this.loading = await false


  	},
  	async refreshConnectedData()
  	{
  		this.data = await this.generalApiGetWithoutLoader("get_current_sockets")  	
      console.log("refreshConnectedData")	
      console.log(this.data)
  		await this.findUnique()
  	},
  	
  }
}
</script>

<style lang="css" scoped>
	.userlist{
		list-style: none;
		margin: 0;
		padding: 0;
	}
</style>